export enum PaymentType {
  Purchase = 'purchase',
  Refill = 'refill',
  Refund = 'refund'
}
